module.exports = __webpack_public_path__ + "static/media/amanjoshi.90913c8c.jpg";